import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './text-editor.component';

import { FroalaEditorModule } from 'angular-froala-wysiwyg';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TextEditorComponent],
  imports: [
    CommonModule,
    FormsModule,
    FroalaEditorModule.forRoot(),
  ],
  exports: [TextEditorComponent],
})
export class TextEditorModule {}
